import React from 'react';
import {
  isPlatform,
  IonContent,
  IonButton,
  IonGrid,
  IonIcon,
  IonPage
} from '@ionic/react';
import './PageNotFound.scss';
import { ICON_PATH, OOPS_NO_RECORD_FOUND_MESSAGE, TAB_NAME } from "../../../../utils/constants";
import { createBrowserHistory } from 'history';
import { getReduxData } from 'app/utils/common';


export interface IPageNotFoundProps {
  showErrorMessagePage: boolean;
  onBackBtnClicked: () => void;
}

export const PageNotFound: React.FC = (props: any) => {
  const history = createBrowserHistory();
  const isDesktop = isPlatform("desktop");

  const onBackBtnClicked = async () =>{
    await props.clearError();
    history.goBack();
    setTimeout( () => { props.clearError()}, 0);
  }

  const  onHomeBtnClicked =  async () => {
    await props.clearError();
    const tabName = getReduxData(TAB_NAME);
    history.push(tabName);
    setTimeout( () => { props.clearError()}, 0);
  }

  return (
    <>
      <IonPage>
        <IonContent fullscreen={isDesktop} class='pageNotFound_page'>
          <IonIcon src={ICON_PATH.pageNotFound} class='pageNotFound_icon' />
          <IonGrid class='textGrid'>
              <IonGrid class='text1_grid'>{OOPS_NO_RECORD_FOUND_MESSAGE.PAGE_NOT_FOUND_MESSAGE1}</IonGrid>
              <IonGrid class='text2_grid'>{OOPS_NO_RECORD_FOUND_MESSAGE.PAGE_NOT_FOUND_MESSAGE2}</IonGrid>
              <IonGrid class='text3_grid'>{OOPS_NO_RECORD_FOUND_MESSAGE.PAGE_NOT_FOUND_MESSAGE3}</IonGrid>
          </IonGrid>
          <IonGrid class='buttonGrid'>
            <IonButton onClick={onBackBtnClicked} class="buttons backButton">{OOPS_NO_RECORD_FOUND_MESSAGE.BACK_BTN}</IonButton>
            <IonButton onClick={onHomeBtnClicked} class="buttons homeButton">{OOPS_NO_RECORD_FOUND_MESSAGE.HOME_BTN}</IonButton>
          </IonGrid>
        </IonContent>
      </IonPage>
    </>
  );
};
export default PageNotFound;
